module.exports = __webpack_public_path__ + "src/assets/img/hatch-img.dbc35e97.png";